import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { WebView } from 'react-native-webview';
import { useTheme } from '../contexts/ThemeContext';

const CritikiArchiveScreen: React.FC = () => {
  const { themeData } = useTheme();
  
  // Get the base URL for the API
  const getBaseUrl = () => {
    if (Platform.OS === 'web') {
      return window.location.origin;
    }
    // For mobile, you might want to use your actual API URL
    return 'http://localhost:3001';
  };

  const archiveUrl = `${getBaseUrl()}/critiki-archive`;

  return (
    <View style={[styles.container, { backgroundColor: themeData.colors.background }]}>
      <WebView
        source={{ uri: archiveUrl }}
        style={styles.webview}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        startInLoadingState={true}
        scalesPageToFit={true}
        allowsInlineMediaPlayback={true}
        mediaPlaybackRequiresUserAction={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  webview: {
    flex: 1,
  },
});

export default CritikiArchiveScreen;
